import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { createCompany } from 'src/api';
import { history } from 'kts-platform-frame/routes';

class ModulesAction extends ActionBasic<ModulesState> {
    /** 控制密码是否可见 */
    public handlePwdShow = () => {
        this.modulesState.ispwdOpen = !this.modulesState.ispwdOpen;
        this.setModulesState();
    }
    /** 是否同意用户协议 */
    public agree = (e) => {
        this.modulesState.isAgree = e.target.checked;
        this.setModulesState();
    }
     /** 获取国家列表 */
     public getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            this.modulesState.countryList = res.res.countryList;
            this.setModulesState();
        }
    }
     /** 国家选择变化 */
     public countryChange = (value) => {
        if (value === 'CHN') {
            this.modulesState.isChina = true;
        }  else {
            this.modulesState.isChina = false;
        }
        this.setModulesState();
    }
    /** 获取省 */
    public getProvince = async (province) => {
        const res = await createCompany.state(this, {countryCode: province});
        if (!res.er) {
           this.modulesState.provinceList = res.res.provinceList;
           this.setModulesState();
        }
    }
    /** 省下拉框改变 */
    public provinceChange = async (value) => {      
        const res = await createCompany.city(this, {stateCode: value});
        if (!res.er) {
            this.modulesState.cityList = res.res.cityList;
            this.setModulesState();
        }      
    }
    /** 省下拉框改变 */
    public checkCompany = async (ticket) => {  
        this.modulesState.ticket = ticket; 
        const res = await createCompany.check(this, {ticket: ticket});
        if (!res.er) {
            this.modulesState.info = res.res;         
        }   
        this.setModulesState();   
    }
    /** 创建公司 */
    public activeCompany = async (opt) => { 
        let data = {...opt, ticket: this.modulesState.ticket};
        delete data.contactName;   
        const res = await createCompany.active(this, data);
        if (!res.er) {
            this.go('/companyRegister/success');
        }      
    }
    /** 返回登陆页 */
    public go = (router) => {
        history.push(router);
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/apps/Help/Modules.Action.ts